import { useCallback, useState } from 'react'
import { message } from 'antd'
import { useDispatch } from 'react-redux'
import api from '../api'
import { initExcelGeneration, finish } from '../redux/slices/excel'

export default function useExportExcelAsync(url) {
  const dispatch = useDispatch()
  const [exportingExcel, setExportingExcel] = useState(false)
  const [archiveId, setArchiveId] = useState(null)
  const exportExcel = useCallback(async () => {
    setExportingExcel(true)
    try {
      const response = await api.apiClient.post(url)
      setArchiveId(response.archiveId)
      message.success(
        'The Excel file is being generated. This may take a few minutes.',
      )
      dispatch(initExcelGeneration(response.archiveId))
    } catch (e) {
      dispatch(finish(archiveId))
      message.error(
        'Oops, we had a problem exporting to excel. Please try again',
      )
    }
    setExportingExcel(false)
  }, [archiveId, dispatch, url])

  return [exportingExcel, exportExcel, archiveId]
}
